:host {
  --markdown-color: #333;
  --markdown-bg: transparent;
  --markdown-link-color: #007bff;
  --markdown-code-bg: #f8f9fa;
  --markdown-code-color: #e83e8c;
  --markdown-code-border: #e9ecef;
  --markdown-table-border: #dee2e6;
  --markdown-table-header-bg: #f8f9fa;
  --markdown-blockquote-border: #dee2e6;
  --markdown-blockquote-bg: #f8f9fa;
}

.markdown-renderer {
  color: var(--markdown-color);
  background: var(--markdown-bg);
  line-height: 1.6;
  word-wrap: break-word;
}

.markdown-renderer h1,
.markdown-renderer h2,
.markdown-renderer h3,
.markdown-renderer h4,
.markdown-renderer h5,
.markdown-renderer h6 {
  margin: 1em 0 0.5em 0;
  font-weight: 600;
  line-height: 1.25;
}

.markdown-renderer h1 { font-size: 1.5em; }
.markdown-renderer h2 { font-size: 1.3em; }
.markdown-renderer h3 { font-size: 1.2em; }
.markdown-renderer h4 { font-size: 1.1em; }
.markdown-renderer h5 { font-size: 1em; }
.markdown-renderer h6 { font-size: 0.9em; }

.markdown-renderer p {
  margin: 0.5em 0;
}

.markdown-renderer a {
  color: var(--markdown-link-color);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s;
}

.markdown-renderer a:hover {
  border-bottom-color: var(--markdown-link-color);
}

.markdown-renderer code {
  background: var(--markdown-code-bg);
  color: var(--markdown-code-color);
  padding: 2px 4px;
  border-radius: 3px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.9em;
  border: 1px solid var(--markdown-code-border);
}

.markdown-renderer pre {
  background: var(--markdown-code-bg);
  border: 1px solid var(--markdown-code-border);
  border-radius: 6px;
  padding: 1em;
  overflow-x: auto;
  margin: 1em 0;
}

.markdown-renderer pre code {
  background: none;
  border: none;
  padding: 0;
  color: inherit;
}

.markdown-renderer .markdown-image {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin: 0.5em 0;
}

.markdown-renderer .markdown-table {
  width: 100%;
  border-collapse: collapse;
  margin: 1em 0;
  border: 1px solid var(--markdown-table-border);
  border-radius: 6px;
  overflow: hidden;
}

.markdown-renderer .markdown-table th,
.markdown-renderer .markdown-table td {
  padding: 0.75em;
  text-align: left;
  border-bottom: 1px solid var(--markdown-table-border);
}

.markdown-renderer .markdown-table th {
  background: var(--markdown-table-header-bg);
  font-weight: 600;
}

.markdown-renderer .markdown-table tr:last-child td {
  border-bottom: none;
}

.markdown-renderer blockquote {
  margin: 1em 0;
  padding: 0.5em 1em;
  border-left: 4px solid var(--markdown-blockquote-border);
  background: var(--markdown-blockquote-bg);
  border-radius: 0 4px 4px 0;
}

.markdown-renderer ul,
.markdown-renderer ol {
  margin: 0.5em 0;
  padding-left: 1.5em;
}

.markdown-renderer li {
  margin: 0.25em 0;
}
